import React from 'react';
import Header from '../Components/Header/header';
import ContactComponent from '../Components/Contact/contact'; // Rename to ContactComponent
import Footer from '../Components/Footer/footer';

const Contact = () => {
  return (
    <div>
        <Header/>
        <div className="breadcrumb-container">
        <div className="breadcrumb">
          <h2>Book A Call</h2>
        </div>
      </div>

        <ContactComponent/> {/* Use the renamed component */}
        <Footer/>
    </div>
  );
};

export default Contact;
